type ZoneRetrievalError = {
  wasZoneNotFound: boolean;
  hasUnexpectedError: boolean;
  message: string;
};

const zoneRetrievalError: ZoneRetrievalError = {
  wasZoneNotFound: false,
  hasUnexpectedError: false,
  message: "",
};

export type { ZoneRetrievalError };

export { zoneRetrievalError };
